import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { Toast } from "../../../CustomComponent/toast";
import StepRoutes from "../../../Routes/steps_routes";
import CustomInput from "../../../CustomComponent/custom_input";
import FormSubmitButton from "../../../Components/layouts/formSubmitButton";
import SimpleButton from "../../../Components/layouts/simple_button";
import performRequest from "../../../api/request";
import { Form, Formik } from "formik";
import Footer from "../../../Components/Footer/footer";
import { useSelector } from "react-redux";
import LoadingPage from "../../../Components/layouts/loading";
import CustomTextArea from "../../../CustomComponent/custom_textarea";
import { CustomErrorResponse } from "../../../CustomComponent/custom_error_response";
import { FcBusinessman, FcSelfServiceKiosk } from "react-icons/fc";
import CustomSelect from "../../../CustomComponent/custom_select";
import { courceSchema } from "../../../Schemas/Media And Marketing/cource_detail.schema";
import { useEffect } from "react";
import CustomCheckbox from "../../../CustomComponent/custom_checkbox";
import { useParams } from "react-router-dom";
import { courceInfo, courceNewInfo } from "../../../SchemaInfo/info";
import { courcenewSchema } from "../../../Schemas/Media And Marketing/courseNewAdd.schema";

const EditCourceNamedetails = () => {
  const store = useSelector((store) => store.login.user);
  const [loading, setLoading] = useState(false);
  let { id } = useParams();
  const [socialMedia, setSocialMedia] = useState([]);
  const [courceInfor, setCourceInfor] = useState(courceNewInfo);
  const navigate = useNavigate();
  const [courses, setCourses] = useState([]);

  useEffect(() => {
    setLoading(true);
    performRequest("GET", `/cource/course-view/${id}`)
      .then((res) => {
        if (res.status === 200) {
          setCourceInfor(res.data);
        } else {
          Toast("error", "Error while getting course!");
        }
        setLoading(false);
      })
      .catch((err) => {
        // Toast("error", "Server Error!");
        // console.error(err);
        CustomErrorResponse(err);
      })
      .finally(() => setLoading(false));
  }, [id]);

  const handelSubmit = (values) => {
    performRequest("PATCH", `/cource/course-update/${id}`, values)
      .then((res) => {
        if (res.status === 200) {
          Toast("success", "Course updated successfully!");
          navigate(`/course-name-view/${id}`);
        } else {
          Toast("error", "Error while creating course details");
        }
      })
      .catch((err) => {
        CustomErrorResponse(err);
      })
      .finally(() => setLoading(false));
  };



  if (loading) {
    return <LoadingPage />;
  }

  return (
    <div className="page">
      <div className="page-wrapper">
        <div className="container-xl">
          <div className="page-header d-print-none">
            <div className="row g-2 align-items-center">
              <div className="col">
                <h2 className="page-title mb-1">
                  <FcSelfServiceKiosk></FcSelfServiceKiosk> Courses
                </h2>
                <h4 className="text-muted">
                  <StepRoutes />
                </h4>
              </div>
            </div>
          </div>
          <div className="card my-4">
            <div className="card-header">
              <h2 className="page-title">Edit Course Details</h2>
            </div>
            <Formik
              initialValues={courceInfor}
              validationSchema={courcenewSchema}
              onSubmit={handelSubmit}
              enableReinitialize={true}
            >
              {(props) => (
                <Form>
                  <div className="card-body">
                    {/* <div className="mb-3 row">
                      <label className="w-25 form-label col-3 required">
                        Course Name
                      </label>
                      <div className="w-100 col">
                        <CustomInput
                          type="text"
                          className="form-control"
                          name="courceName"
                        ></CustomInput>
                        {props.touched.courceName &&
                          props.errors.courceName && (
                            <p className="text-danger">
                              {" "}
                              {props.errors.courceName}{" "}
                            </p>
                          )}
                      </div>
                    </div> */}

                    <div className="mb-3 row">
                      <label className="w-25 form-label col-3">
                        Course Name
                      </label>

                      <div className="col-9">
                        <CustomInput name="courseName" type="text" />
                        {props?.touched?.courseName &&
                          props?.errors?.courseName && (
                            <p className="text-danger">
                              {props?.errors?.courseName}
                            </p>
                          )}
                      </div>
                    </div>

                    <div className="row mb-3">
                      <label className="form-label col-3">
                        Course Description
                      </label>
                      <div className="col-9">
                        <CustomTextArea name="courseDes" type="text" />
                        {props?.touched?.courseDes &&
                          props?.errors?.courseDes && (
                            <p className="text-danger">
                              {props?.errors?.courseDes}
                            </p>
                          )}
                      </div>
                    </div>

                    <div className="row mb-3">
                      <label className="form-label col-3">
                        ⁠Course first copy nas url
                      </label>
                      <div className="col-9">
                        <CustomInput name="courseUrl1" type="text" />
                        {props?.touched?.courseUrl1 &&
                          props?.errors?.courseUrl1 && (
                            <p className="text-danger">
                              {props?.errors?.courseUrl1}
                            </p>
                          )}
                      </div>
                    </div>

                    <div className="row mb-3">
                      <label className="form-label col-3">
                        ⁠Course final url
                      </label>
                      <div className="col-9">
                        <CustomInput name="courseUrl2" type="text" />
                        {props?.touched?.courseUrl2 &&
                          props?.errors?.courseUrl2 && (
                            <p className="text-danger">
                              {props?.errors?.courseUrl2}
                            </p>
                          )}
                      </div>
                    </div>
                  </div>
                  <div className="card-footer">
                    <div className="btn-list justify-content-end">
                      <FormSubmitButton buttonText="Edit Course Details" />
                      <SimpleButton buttonText="Cancel" type="secondary" />
                    </div>
                  </div>
                </Form>
              )}
            </Formik>
          </div>
        </div>
        <Footer />
      </div>
    </div>
  );
};
export default EditCourceNamedetails;
